import { keycloakInitTriggered } from './authSlice'; // Action to track initialization
import Keycloak from 'keycloak-js';

let keycloakInstance = null;

export const keycloakMiddleware = (store) => (next) => (action) => {
  if (action.type === 'auth/fetchKeycloakSettings/fulfilled') {
    const { keycloakSettings, tenant } = store.getState().auth;

    // Initialize Keycloak with the fetched settings
    console.log("KEYCLOAK SETTINGS", keycloakSettings, "TENANT", tenant);
}

  return next(action);
};